export interface NavItem {
  name: string;
  path: string;
}

export const navItems: NavItem[] = [
  { name: 'PALVELUT', path: '/services' },
  { name: 'RENGASMYYNTI JA -HOTELLI', path: '/wheels' },
  { name: 'YHTEYSTIEDOT', path: '/contacts' },
];

export const getMarginBottom = (isMdDown: boolean): number => {
  return isMdDown ? 0 : 3;
};

export const getCursor = (isSelected: boolean): 'default' | 'pointer' => {
  return isSelected ? 'default' : 'pointer';
};

export const getDisableRipple = (isSelected: boolean): boolean => {
  return !!isSelected;
};
